import MarkDownRenderer from '../../../../commonComponents/MarkDownRender/MarkDownRender.Component';

export const markdownContent = `
# **Collection Documentation**

HawkClient allows you to create rich, well-structured documentation for your API collections using **Markdown**.  
This makes it easy to add descriptions, usage notes, and team communication directly alongside your requests.

The documentation is displayed within the collection view, making it accessible and visible to anyone exploring the API.

![Collection Documentation View](/docs/CollectionDoc.png)

---

## **Editing Collection Documentation**

To modify the documentation, simply click on the **Edit Mode** button.  
This opens an inline editor where you can write or update content using Markdown syntax.

This feature is especially useful for collaborative teams, helping maintain clarity around the purpose, structure, and expected behavior of API collections.

![Edit Collection Documentation](/docs/CollectionDocEdit.png)
`;

const CollectionDocumentation = () => {
    return (
        <MarkDownRenderer
            title="Collection Documentation"
            markDownText={markdownContent}
        />
    );
};

export default CollectionDocumentation;
